import { z } from 'zod';

const AnimalSpeciesDef = ['Alpaca', 'Cow', 'Deer', 'Goat', 'Horse', 'Pig', 'Sheep'] as const;

export type AnimalSpecies = (typeof AnimalSpeciesDef)[number];

export const animalSpeciesSchema = z.enum(AnimalSpeciesDef);
